/**
 * Sellable Items Utility
 *
 * Shared API functions for fetching sellable items used in automations.
 * Uses /api/v4/upsells/sellable endpoint
 */

import api from 'src/utils/ajax';

export interface SellableItem {
  id: string | number | null;
  name: string;
  type: string;
}

/**
 * Fetch sellable items with subscription options (groups and packages with recurring payments)
 * Also includes ClientAssociation and TrainerAssociation
 * Used by DowngradeAction and ResetBillingAction
 */
export const fetchSubscriptionItems = async (): Promise<SellableItem[]> => {
  const response = await api.get('/api/v4/upsells/sellable', {
    params: { type: 'subscription' },
  });
  return response.data || [];
};

/**
 * Fetch all sellable items (plans, groups, products, packages + associations)
 * No type param returns everything
 */
export const fetchAllSellableItems = async (): Promise<SellableItem[]> => {
  const response = await api.get('/api/v4/upsells/sellable');
  return response.data || [];
};
